import Phaser from 'phaser';
import { IS_PORTRAIT_LAYOUT } from '../core/Config';
import { GameSettings } from '../core/GameSettings';

export class InteractionPrompt {
  private readonly container: Phaser.GameObjects.Container;
  private readonly bubble: Phaser.GameObjects.Rectangle;
  private readonly icon: Phaser.GameObjects.Text;
  private readonly label: Phaser.GameObjects.Text;

  constructor(private readonly scene: Phaser.Scene) {
    const mobile = IS_PORTRAIT_LAYOUT;
    const height = mobile ? 68 : 42;
    this.bubble = scene.add
      .rectangle(0, 0, mobile ? 190 : 124, height, 0x172019, 0.94)
      .setStrokeStyle(mobile ? 3 : 2, 0xe8c768, 0.9)
      .setOrigin(0.5);
    this.icon = scene.add.text(mobile ? -72 : -42, mobile ? -19 : -12, mobile ? 'A' : 'F', {
      fontSize: mobile ? '31px' : '20px',
      color: '#ffe391',
      fontStyle: 'bold',
    });
    this.label = scene.add.text(mobile ? -26 : -18, mobile ? -17 : -10, '대화', {
      fontSize: mobile ? '28px' : '18px',
      color: '#eff8ed',
    });
    this.container = scene.add.container(0, 0, [this.bubble, this.icon, this.label]).setDepth(9990).setVisible(false);
    if (!mobile) {
      scene.tweens.add({ targets: this.container, y: '+=6', duration: 620, yoyo: true, repeat: -1, ease: 'sine.inOut' });
    }
  }

  showAt(x: number, y: number, label: string) {
    if (!GameSettings.get('interactionBubble')) { this.hide(); return; }
    this.label.setText(label);
    const mobile = IS_PORTRAIT_LAYOUT;
    const width = Math.max(mobile ? 190 : 124, (mobile ? 108 : 70) + this.label.width);
    this.bubble.setSize(width, mobile ? 68 : 42);
    this.icon.setX(-width / 2 + (mobile ? 26 : 18));
    this.label.setX(-width / 2 + (mobile ? 72 : 42));
    this.container.setPosition(x, y);
    this.container.setVisible(true).setAlpha(1);
  }

  hide() { this.container.setVisible(false); }
}
